import type { TJsonQuery } from '../../../packages/JsonQuery';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export function getIsEtazhiBlackFridayFilterEnabled(jsonQuery: TJsonQuery) {
  const isEnabled = !!jsonQuery?.is_black_friday_etazhi;

  return isEnabled;
}
